module.exports = __webpack_public_path__ + "static/contact-hero-7e682deedb006dec474c022828792da6.jpg";